"use client";

import { UsersAssignation } from "components/ui/v2/certificates/bundle/Certificates/Forms/UsersAssignation";
import { ICertificate } from "gql/Certificates/queries";

export interface UsersAssignationModalContentV2Props {
  certificate?: ICertificate;
  hideHeader?: boolean;
  onLoadingChange?: (loading: boolean) => void;
}

export function UsersAssignationModalContentV2({
  certificate,
  hideHeader = true,
  onLoadingChange,
}: UsersAssignationModalContentV2Props) {
  return (
    <UsersAssignation
      certificate={certificate}
      hideHeader={hideHeader}
      onLoadingChange={onLoadingChange}
    />
  );
}
